export const publicVersion = "2.8.0-2-g8c39a973-2026-05-16T07-42-52Z";